import { useState } from 'react';
import ScoreModal from './ScoreModal';
import { IconCheck } from './TournamentIcons';
import { MemberStack } from '../memberDisplay';

/**
 * onScoreModalOpen(matchId)  — вызывается при открытии ScoreModal
 * onScoreModalClose(matchId) — вызывается при закрытии ScoreModal (cancel или 409)
 * Используются в TournamentPage для умного мёржа SSE-снапшота.
 */
const MatchRow = ({ match, playerMap, canEdit, onScoreSaved, publicId, tournament, roundNumber, onScoreModalOpen, onScoreModalClose, clientId }) => {
  const [modalOpen, setModalOpen] = useState(false);

  // Игроки команд как объекты (с alias/ником) — для единого отображения имени.
  const teamAPlayers = (match.teamAPlayerIds || []).map(id => playerMap[id]).filter(Boolean);
  const teamBPlayers = (match.teamBPlayerIds || []).map(id => playerMap[id]).filter(Boolean);
  const teamANames = teamAPlayers.map(p => p.displayName).join(' / ') || '—';
  const teamBNames = teamBPlayers.map(p => p.displayName).join(' / ') || '—';

  const isFinished = match.status === 'FINISHED';
  const hasScore   = match.teamAScore != null && match.teamBScore != null;

  const handleClose = () => {
    setModalOpen(false);
    onScoreModalClose?.(match.id);
  };
  const winnerA    = isFinished && (match.teamAScore ?? 0) > (match.teamBScore ?? 0);
  const winnerB    = isFinished && (match.teamBScore ?? 0) > (match.teamAScore ?? 0);

  return (
    <>
      <div
        onClick={canEdit ? () => {
          setModalOpen(true);
          // Передаём колбэк закрытия вторым аргументом — TournamentPage сохраняет его
          // в ref и использует для принудительного закрытия модала при SSE-конфликте.
          onScoreModalOpen?.(match.id, handleClose);
        } : undefined}
        style={{
          borderRadius: 10,
          border: '1.5px solid #f0f0f5',
          background: isFinished ? '#f9fafb' : '#fff',
          overflow: 'hidden',
          cursor: canEdit ? 'pointer' : 'default',
        }}
      >
        {/* Корт */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '5px 12px',
          background: '#f8fafc',
          borderBottom: '1px solid #f0f0f5',
        }}>
          <span style={{ fontSize: 11, fontWeight: 700, color: '#9ca3af', letterSpacing: 0.5 }}>
            КОРТ {match.courtNumber}
          </span>
          {isFinished
            ? <IconCheck />
            : canEdit && (
              <span style={{ fontSize: 10, color: '#d97706', fontWeight: 600 }}>
                нажмите для ввода счёта
              </span>
            )
          }
        </div>

        {/* Счёт + команды. Игроки каждой команды — на отдельных строках,
            чтобы имена не сливались и не обрезались счётом. */}
        <div style={{ display: 'flex', alignItems: 'center', padding: '10px 12px', gap: 6 }}>
          {/* Команда A */}
          <div style={{ flex: 1, minWidth: 0 }}>
            {teamAPlayers.map((p, i) => (
              <div key={i} style={{ marginBottom: i < teamAPlayers.length - 1 ? 4 : 0, overflow: 'hidden' }}>
                <MemberStack member={p} fontSize={13} color={winnerA ? '#111827' : '#374151'} align="left" />
              </div>
            ))}
          </div>

          {/* Счёт */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
            <span style={{
              fontSize: 18, fontWeight: 700,
              color: winnerA ? '#d97706' : (hasScore ? '#374151' : '#d1d5db'),
              minWidth: 20, textAlign: 'center',
            }}>
              {hasScore ? match.teamAScore : '—'}
            </span>
            <span style={{ fontSize: 14, color: '#d1d5db', fontWeight: 400 }}>:</span>
            <span style={{
              fontSize: 18, fontWeight: 700,
              color: winnerB ? '#d97706' : (hasScore ? '#374151' : '#d1d5db'),
              minWidth: 20, textAlign: 'center',
            }}>
              {hasScore ? match.teamBScore : '—'}
            </span>
          </div>

          {/* Команда B */}
          <div style={{ flex: 1, minWidth: 0, textAlign: 'right' }}>
            {teamBPlayers.map((p, i) => (
              <div key={i} style={{ marginBottom: i < teamBPlayers.length - 1 ? 4 : 0, overflow: 'hidden' }}>
                <MemberStack member={p} fontSize={13} color={winnerB ? '#111827' : '#374151'} align="right" />
              </div>
            ))}
          </div>
        </div>
      </div>

      {modalOpen && (
        <ScoreModal
          match={match}
          teamANames={teamANames}
          teamBNames={teamBNames}
          teamAPlayers={teamAPlayers}
          teamBPlayers={teamBPlayers}
          publicId={publicId}
          tournament={tournament}
          roundNumber={roundNumber}
          onSaved={onScoreSaved}
          onClose={handleClose}
          clientId={clientId}
        />
      )}
    </>
  );
};

export default MatchRow;
